module.exports = __webpack_public_path__ + "static/media/covid-virus-logo.8193ad20.png";